import { render } from "./SellersView.vue?vue&type=template&id=2b185edc&scoped=true&ts=true"
import script from "./SellersView.vue?vue&type=script&lang=ts"
export * from "./SellersView.vue?vue&type=script&lang=ts"

import "./SellersView.vue?vue&type=style&index=0&id=2b185edc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b185edc"]])

export default __exports__